module.exports = __webpack_public_path__ + "static/img/frede.b4e97f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frede.png
// module id = KK/0
// module chunks = 0